// ISO 3166-1 alpha-2 codes of the 49 countries that have no ISO 3166-2
// subdivisions (CHA1-3722, §11.8). State / Region is hidden for these and
// rendered + required for every other country. Mirrors
// COUNTRY_CODES_WITHOUT_SUBDIVISIONS in the backend's
// consumer_clarity/constants/configure.py - keep the two lists identical.
export const COUNTRY_CODES_WITHOUT_SUBDIVISIONS = [
  "AI",
  "AQ",
  "AS",
  "AW",
  "AX",
  "BL",
  "BM",
  "BV",
  "CC",
  "CK",
  "CW",
  "CX",
  "EH",
  "FK",
  "FO",
  "GF",
  "GG",
  "GI",
  "GP",
  "GS",
  "GU",
  "HK",
  "HM",
  "IM",
  "IO",
  "JE",
  "KY",
  "MF",
  "MO",
  "MP",
  "MQ",
  "MS",
  "NC",
  "NF",
  "NU",
  "PF",
  "PM",
  "PN",
  "PR",
  "RE",
  "SJ",
  "SX",
  "TC",
  "TF",
  "TK",
  "VA",
  "VG",
  "VI",
  "YT"
]

export const countryHasSubdivisions = (countryCode) =>
  !COUNTRY_CODES_WITHOUT_SUBDIVISIONS.includes(
    String(countryCode ?? "")
      .trim()
      .toUpperCase()
  )
